<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top: 1.5em; font-size:150%"><a id="dedi"></a></div>
<p class="dedication">A la Lamia del Iturrigorri</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 16_dedi.vue?f09dbfaa